import { Col, Row } from "react-grid-system";
import IAudienceListProps from "./IAudienceListProps";
import { Button, Table, TableBody, TableCell, TableCellActions, TableCellLayout, TableRow } from "@fluentui/react-components";
import { Delete16Filled } from "@fluentui/react-icons";
import { mergeStyles } from "@fluentui/merge-styles";
import useStyleUtils from "../../../../utilities/styles";

export default function AudienceList(props: IAudienceListProps) {
    const style = useStyleUtils();

    if (props.selectedGroups.length === 0) {
        return (
            <p>{props.noGroupsSelectedText}</p>
        );
    }

    const groups = props.selectedGroups.sort((a, b) => a.name.localeCompare(b.name));

    const btnRemoveStlyes = mergeStyles({ color: "red" });
    const btnRemoveClassName = mergeStyles(style.mr2, btnRemoveStlyes);

    return (
        <Row>
            <Col>
                <p>
                    {props.selectedText}
                </p>
                <Table>
                    <TableBody>
                        {
                            groups.map((group) => (
                                <TableRow key={group.id}>
                                    <TableCell>
                                        <TableCellLayout>
                                            {group.name}
                                        </TableCellLayout>
                                        <TableCellActions>
                                            <Button
                                                size="small"
                                                appearance="subtle"
                                                icon={<Delete16Filled />}
                                                className={btnRemoveClassName}
                                                onClick={() => props.onRemove(group.id)} />
                                        </TableCellActions>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Col>
        </Row>
    );
}